import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from "./public/login/login.component";
import { authGuard, consentEntryGuard, consentGuard, redirectIfAuthedGuard } from '../../../chat-common/src/lib/guards/auth.guard';
import { RegisterComponent } from './public/register/register.component';
import { ConsentComponent } from './public/consent/consent.component';
import { ChatGptComponent } from './chat-gpt/chat-gpt.component';
import { BcraReportComponent } from './report/bcra/bcra-report.component';
import { reportAuthGuard } from './report/report-auth.guard';

const routes: Routes = [
  { path: '', redirectTo: 'health-assistant', pathMatch: 'full' },

  { path: 'home', component: LoginComponent, canActivate: [redirectIfAuthedGuard] },

  { path: 'login', component: LoginComponent, canActivate: [redirectIfAuthedGuard] },

  { path: 'register', component: RegisterComponent, canActivate: [redirectIfAuthedGuard] },

  { path: 'consent', component: ConsentComponent, canActivate: [consentEntryGuard] },

 { path: 'health-assistant', component: ChatGptComponent, canActivate: [authGuard, consentGuard] },

  { path: 'report/BCRA', component: BcraReportComponent, canActivate: [reportAuthGuard] },

  { path: '**', redirectTo: 'health-assistant' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
